"use strict";

angular.module("core")
.component("paymentDueDateFilter", {
    templateUrl: require("./payment-due-date-filter.component.html"),
    controllerAs: "paymentDueDateFilterCtrl",
    controller: function($scope) {
        this.updateFilter = function(isOverdue) {
            $scope.$emit("paymentDueDateFilterUpdated", {is_overdue: isOverdue});
        };
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/payment-due-date-filter/payment-due-date-filter.component.js
// module id = 596
// module chunks = 0